import { PrimaryButton } from './form';
import {
  StyledWrapper,
  StyledFloatLeft,
  StyledFloatRight,
  StyledWrapperRight,
  StyledWrapperLeft,
  StyledSider,
  StyledMenu,
  DrawerFooter
} from './layout';

export default {
  layout: {
    StyledWrapper,
    StyledFloatLeft,
    StyledFloatRight,
    StyledWrapperRight,
    StyledWrapperLeft,
    StyledSider,
    StyledMenu,
    DrawerFooter
  },
  form: {
    PrimaryButton
  },
  table: {
  }
};
